"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _LogChip = _interopRequireDefault(require("./LogChip"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var LogMention = function LogMention(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LogChip["default"], {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.PersonIcon, {
      sx: {
        fontSize: 16
      }
    }),
    label: children
  });
};
var _default = exports["default"] = LogMention;